import React, { useState, useEffect } from 'react';
import { MDBDataTable } from 'mdbreact';
import { Form, Col, Row } from 'react-bootstrap';
import { Button, Container } from '@mui/material';
import Swal from 'sweetalert2';
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import { RiDeleteBinFill } from "react-icons/ri";
import { FaEdit } from "react-icons/fa";
import { FaEye } from "react-icons/fa6";
import "../../assets/css/custom.css";
import axios from 'axios';
import { baseURL } from '../base_url';
import { PuffLoader } from 'react-spinners';
import moment from 'moment';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosConfig';

const Company = () => {
  const navigate = useNavigate();
  const [DisplyForm, setDisplyForm] = useState(false)
  const [companyName, setCompanyName] = useState('')
  const [contactPerson, setContactPerson] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [address, setAddress] = useState('')
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState('');
  const [note, setNote] = useState('')
  const [loading, setLoading] = useState(false);
  const [accessDetails, setAccessDetails] = useState([]);
  const [updateFlag, setUpdateFlag] = useState(false);
  const [isActive, setIsActive] = useState(false)
  const [viewEditButton, setViewEditButton] = useState(true)
  const [isEdited, setIsEdited] = useState('');
  const [errors, setErrors] = useState({
    companyName: '',
    contactPerson: '',
    email: '',
    phoneNumber: '',
    zipCode: '',
  });
  
  const loggedInUser = sessionStorage.getItem("tm_token");
  const foundUser = JSON.parse(loggedInUser);
  const authToken = foundUser['auth_token'];

  useEffect(() => {
    setLoading(true);
    axiosInstance.get(baseURL + "/get_company_setup?status=all&admin_id=" + foundUser['tm_id'])
    .then((res) => {
      var j = 1;
      if(res.data.status === '1'){
        let rowsData = [];
        const myDataSet = res.data.data;
        for (var index = 0; index < res.data.data.length; index++) {
          let rowItem = {};
          const val = myDataSet[index];
          rowItem["id"] = j++;
          rowItem["c_name"] = val.company_name;
          rowItem["c_mail"] = val.email;
          rowItem["creat_name"] = val.c_name;
          rowItem['c_date'] = moment(new Date(val.created_date)).format('MM/DD/YYYY hh:mm A');
          rowItem['status'] = (val.is_active === 'True' ? 'Active':'In-Active');
          rowItem['action'] = (<React.Fragment><FaEye title='View' onClick={() => vieweditHandle("view-"+val._id)} style={{ marginLeft: '8px', cursor: 'pointer' }}/> {foundUser['tm_accessRole']['Company']['Edit'] == true && (<>|<FaEdit title='Edit' onClick={() => vieweditHandle("edit-"+val._id)} style={{ marginLeft: '8px', cursor: 'pointer' }}/></>)} {foundUser['tm_accessRole']['Company']['Delete'] == true && (<>| <RiDeleteBinFill  title='Delete' onClick={() => deleteHandle(val._id)} style={{ cursor: 'pointer' }}/></>)}</React.Fragment>)
          rowsData.push(rowItem)
        }
        setAccessDetails(rowsData);
      }else{
        setAccessDetails([]);
      }
      setLoading(false);
    })
  },[updateFlag]);

  const handleCountry = (value) => {
    const data = State.getAllStates();
    let filteredData = [];
    for (let item of data) {
      if (item?.countryCode === value?.isoCode) filteredData.push(item);
    }
    setStateData(filteredData);
    setState("");
  };
  // const deleteHandle = (id) => {
  //   Swal.fire({
  //     title: 'Are you sure you want to delete?',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //   }).then((result) => {
  //     /* Read more about isConfirmed, isDenied below */
  //     if (result.isConfirmed) {
  //       setLoading(true);
  //       axiosInstance.post(baseURL + "/company_delete",
  //         {"id":id,"admin_id":foundUser['tm_id']}
  //       ).then((res) => {
  //         if(res.data.status === '1'){
  //           Swal.fire('Deleted!', 'Company has been deleted.', 'success')
  //         }else{    
  //           Swal.fire("Something went wrong!!")
  //         }
  //         setLoading(false);
  //       })
  //       setUpdateFlag(!updateFlag);
  //     }
  //   })
  // }

    const deleteHandle = async (id) => {
  const result = await Swal.fire({
    title: 'Are you sure you want to delete?',
    showCancelButton: true,
    confirmButtonText: 'Yes',
  });

  if (result.isConfirmed) {
    setLoading(true);
    try {
      const res = await axiosInstance.post(baseURL + "/company_delete", {
        "id": id,
        "admin_id": foundUser['tm_id']
      });
      if (res.data.status === '1') {
        Swal.fire('Deleted!', 'Company has been deleted.', 'success');
      } else {
        Swal.fire("Something went wrong.");
      }
      setUpdateFlag(!updateFlag);
    } catch (err) {
      if (err.response && err.response.status === 429) {
        Swal.fire('Too Many Requests', 
          'You have exceeded the allowed number of delete requests. Please wait and try again.', 
          'warning');
      } else {
        Swal.fire('Oops!', 'Unexpected error occurred.', 'error');
      }
    } finally {
      setLoading(false);
    }
  }
}
  const handleIsActive = (e) => {
    setIsActive(e.target.checked);
  }
  const handleState = (value) => {
    let filteredData = [];
    const data = City.getAllCities();
    for (let item of data) {
      if (
        value?.countryCode === item?.countryCode &&
        value?.isoCode === item?.stateCode
      ) {
        filteredData.push(item);
      }
    }
    setCityData(filteredData);
    setCity("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setCompanyName('');
    setContactPerson('');
    setEmail('');
    setPhoneNumber('');
    setAddress('');
    setCountry('');
    setState('');
    setCity('');
    setZipCode('');
    setNote('');
    setDisplyForm(true)
    setViewEditButton(true);
    setIsEdited('');
  }
  const handleSubmitForm = (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(companyName.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter company name.'})
      return;
    }
    if(contactPerson.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter contact person.'})
      return;
    }
    if(email.toString().trim() === ''){
      Swal.fire({icon: 'error',
                text: 'Please enter Email-id.'})
      return;
    }
    if (!emailRegex.test(email)){
      Swal.fire({icon: 'error',
                text: 'Please enter valid Email-id.'})
      return;
    }
    const payload = {
      'admin_id': foundUser['tm_id'],
      'company_name': companyName.toString(),
      'contact_person': contactPerson.toString(),
      'email':email.toString(),
      'phone_number':phoneNumber?phoneNumber.toString():"",
      'address':address?address.toString():"",
      'country':country?country.name.toString():"",
      'state':state?state.name.toString():"",
      'city':city?city.name.toString():"",
      'zipCode':zipCode?zipCode.toString():"",
      'note':note?note.toString():"",
      'status': isActive,
      'is_edited': isEdited
    }

    const payloadSize = new Blob([JSON.stringify(payload)]).size;
    if (payloadSize > (1 * 1024 * 1024)) {
      Swal.fire({
        icon: 'error',
        title: 'Payload too large',
        text: 'Your input data exceeds the allowed limit (1 MB). Please shorten some fields.'
      });
      return;
    }


    setLoading(true);
    axiosInstance.post(baseURL + "/create_company", payload).then((res) => {
      setLoading(false);
      if (res.data.status === 'success'){
        setDisplyForm(false)
        let msg = companyName.toString() + " created successfully.";
        Swal.fire({icon: 'success',
          text: msg
        })
      }else if (res.data.status === 'duplicate'){
        Swal.fire("<b>"+companyName.toString() + "</b> already exist, Please try with different company name.")
        return;
      }else if (res.data.status === 'updated'){
        setDisplyForm(false)
        let msg = companyName.toString() + " updated successfully.";
        Swal.fire({icon: 'success',
          text: msg
        })
      }else{
        Swal.fire("Something went wrong.")
        return;
      }
      setUpdateFlag(!updateFlag);
    })
    .catch((err) => {
      setLoading(false);
      if (err.response && err.response.status === 429) {
        Swal.fire({
          icon: 'warning',
          title: 'Too Many Requests',
          text: 'You have exceeded the allowed number of requests. Please wait a minute before trying again.'
        });
      }else if (err.response && err.response.status === 413) {
        Swal.fire({
          icon: 'error',
          title: 'Payload Too Large',
          text: 'The data you submitted is too large. Please reduce your input.'
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An unexpected error occurred.'
        });
        console.error("API error:", err);
      }
    });
  }
  const vieweditHandle = (id) => {
    setLoading(true);
    const explodedArray = id.split('-');
    axios.post(baseURL + "/get_company_single",{"id":explodedArray[1]}).then((res) => {
      if(res.data.status === '1'){
        handleCountry(Country.getAllCountries().find(option => option.name === res.data.data.country))
        setTimeout(() => {
          setState(stateData.find(option => option.name === res.data.data.state));
          handleState(stateData.find(option => option.name === res.data.data.state))
          setTimeout(() => {
            setCity(cityData.find(option => option.name === res.data.data.city));
          }, 2000);
        }, 2000);
        setDisplyForm(true)
        setCompanyName(res.data.data.company_name);
        setContactPerson(res.data.data.contact_person);
        setEmail(res.data.data.email);
        setPhoneNumber(res.data.data.phone_number);
        setCountry(Country.getAllCountries().find(option => option.name === res.data.data.country));
        setState(State.getAllStates().find(option => option.name === res.data.data.state));
        setCity(City.getAllCities().find(option => option.name === res.data.data.city));
        setAddress(res.data.data.address);
        setZipCode(res.data.data.zipCode);
        setNote(res.data.data.note);
        if (res.data.data.is_active === 'True'){
          setIsActive(true);
        }else{
          setIsActive(false);
        }
        if (explodedArray[0] === 'view'){
          setViewEditButton(false)
        }else{
          setIsEdited(res.data.data._id)
          setViewEditButton(true)
        }
      }else{
        Swal.fire("Something went wrong.")
        return;
      }
      setLoading(false);
    })
  }
  const cancelForm = (e) => {
    e.preventDefault();
    setDisplyForm(false)
  }
  const data = {
    columns: [
      {
        label: 'S.No',
        field: 'id',
      },
      {
        label: 'Company Name',
        field: 'c_name',
      },
      {
        label: 'Contact Email',
        field: 'c_mail',
      },
      {
        label: 'Create By',
        field: 'creat_name',
      },
      {
        label: 'Created DateTime',
        field: 'c_date',
      },
      {
        label: 'Status',
        field: 'status',
      },
      {
        label: 'Action',
        field: 'action',
      },
    ],
    rows: accessDetails
  };
  const searchOptions = {
      text: 'Search by name', // Placeholder text for the search input
      showSearch: true, // Show the search input
      searchLabel: 'Search:', // Label for the search input
    };
      
  return(
      <div className='body_class'>
        {loading ? (
            <div className="loader-overlay">
                <div className="loader">
                <PuffLoader color="#00308F" loading={true} size={200} />
                </div>
            </div>
        ) : ("")}
          <div className='container-fluid'>
            {!DisplyForm ? (
            <>
            <div className="mt-5">
            {foundUser['tm_accessRole']['Company']['Add'] == true &&
              <Button size="large" type="submit" variant="contained" onClick={handleSubmit}>
                  + Add Company
              </Button>
            }
            </div>
            <div className="row mt-1">
              <div className="col-md-12">
                <MDBDataTable
                  bordered
                  data={data}
                  large={false}
                  displayEntries={false}
                  search={searchOptions}
                  noBottomColumns={true}
                  className="pagination-right-aligned"
                  searching={true}
                />
              </div>
            </div>
            </>
            ):(
              <>
              <h4>Add Company</h4>
              <div className='mt-4'>
              <div className='container-fluid'>
              {/* <Form onSubmit={handleSubmitForm}>
              <div className='p-3 madatory_fields'>
                <div className="form_section">**Mandatory Fields**</div>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">
                      Company Name *
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='text' value={companyName} onChange={(e)=>setCompanyName(e.target.value)} placeholder='Company Name' />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCP">
                    <Form.Label column sm="2">
                      Contact Person *
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='text' value={contactPerson} onChange={(e)=>setContactPerson(e.target.value)} placeholder='Contact Person' />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">
                      Email *
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='email' value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='Email'/>
                    </Col>
                  </Form.Group>
              </div>
              
              <div className='p-3 madatory_fields'>
                <div className="form_section">**Non Mandatory Fields**</div>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextPN">
                    <Form.Label column sm="2">
                      Phone Number
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='text' value={phoneNumber} onChange={(e)=>setPhoneNumber(e.target.value)} placeholder='Phone Number'/>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextAddress">
                    <Form.Label column sm="2">
                      Address
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control type='text' value={address} onChange={(e)=>setAddress(e.target.value)} placeholder='Address' />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCountry">
                    <Form.Label column sm="1">
                      Country
                    </Form.Label>
                    <Col sm="2">
                    <Select
                        placeholder={"Country"}
                        options={Country.getAllCountries()}
                        value={country}
                        getOptionLabel={(options) => options.name}
                        getOptionValue={(options) => options.name}
                        onChange={(e) => {
                        setCountry(e);
                        handleCountry(e);
                        }}
                    />
                    </Col>
                    <div className='col-1'></div>
                    <Form.Label column sm="1">
                      State
                    </Form.Label>
                    <Col sm="2">
                    <Select
                        placeholder={"State"}
                        value={state}
                        options={stateData}
                        getOptionLabel={(options) => options.name}
                        getOptionValue={(options) => options.name}
                        onChange={(e) => {
                        setState(e);
                        handleState(e);
                        }}
                    />
                    </Col>
                    <div className='col-1'></div>
                    <Form.Label column sm="1">
                      City
                    </Form.Label>
                    <Col sm="2">
                    <Select
                        placeholder={"City"}
                        value={city}
                        options={cityData}
                        getOptionLabel={(options) => options.name}
                        getOptionValue={(options) => options.name}
                        onChange={(e) => {
                        setCity(e);
                        }}
                    />
                    </Col>
                  </Form.Group>
                  
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextZip">
                    <Form.Label column sm="2">
                      Zip Code
                    </Form.Label>
                    <Col sm="5">
                      <Form.Control type='text' value={zipCode} onChange={(e)=>setZipCode(e.target.value)} placeholder='Zip Code' />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextNote">
                    <Form.Label column sm="2">
                      Note
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control as="textarea" value={note} onChange={(e)=>setNote(e.target.value)} rows={3} placeholder='Note' />
                    </Col>
                  </Form.Group>
              </div>
                  <div style={{textAlign:"center"}} className=''>
                  <Form.Group as={Row} className="mt-4" controlId="formPlaintextCheckbox">
                    <Col sm="5"></Col>
                        <Col sm="1">
                        <Form.Check
                            type="checkbox"
                            id="checkbox"
                            label="Is&nbsp;Active"
                            checked={isActive}
                            onChange={handleIsActive}
                        />
                        </Col>
                    </Form.Group>
                    {viewEditButton && 
                      <Button variant="contained" type="submit">
                        Submit
                      </Button>
                    }
                    <Button variant="outlined" type="submit" className="m-4" onClick={cancelForm}>
                      Cancel
                    </Button>
                  </div>
                </Form> */}

              {/* GTIS validation */}
              <Form onSubmit={handleSubmitForm}>
                <div className='p-3 madatory_fields'>
                  <div className="form_section">**Mandatory Fields**</div>
                  {/* Company Name */}
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">Company Name *</Form.Label>
                    <Col sm="5">
                      <Form.Control
                        type='text'
                        value={companyName}
                        maxLength={51}
                        placeholder='Company Name'
                        onChange={(e) => {
                        const rawVal = e.target.value;
                          if (rawVal.length > 50) {
                            setErrors(prev => ({ ...prev, companyName: 'Company Name cannot exceed 50 characters.' }));
                            return;
                          }
                        // const cleanedVal = rawVal.replace(/[0-9]/g, '');
                        const cleanedVal = rawVal.replace(/[^a-zA-Z\s]/g, '');
                        setCompanyName(cleanedVal);

                        if (rawVal.trim() === '') {
                          setErrors(prev => ({ ...prev, companyName: 'Company Name is required.' }));
                        } else if (/\d/.test(rawVal)) {
                          setErrors(prev => ({ ...prev, companyName: 'Company Name should not contain numbers.' }));
                        } else if (/[^a-zA-Z\s]/.test(rawVal)) {
                          setErrors(prev => ({ ...prev, companyName: 'Company Name should not contain special characters.' }));
                        }else if (cleanedVal.trim().length < 3) {
                          setErrors(prev => ({ ...prev, companyName: 'Company Name must be at least 3 characters.' }));
                        } else {
                          setErrors(prev => ({ ...prev, companyName: '' }));
                        }
                      }}
                      />
                      {errors.companyName && <small className="text-danger d-block mt-1">{errors.companyName}</small>}
                    </Col>
                  </Form.Group>

                  {/* Contact Person */}
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextCP">
                    <Form.Label column sm="2">Contact Person *</Form.Label>
                    <Col sm="5">
                      <Form.Control
                        type='text'
                        value={contactPerson}
                        placeholder='Contact Person'
                        onChange={(e) => {
                          const rawVal = e.target.value;

                          // Max length check first
                          if (rawVal.length > 50) {
                            setErrors(prev => ({ ...prev, contactPerson: 'Contact Person name cannot exceed 50 characters.' }));
                            return;
                          }

                          // Remove invalid characters: allow only letters and spaces
                          const cleanedVal = rawVal.replace(/[^A-Za-z ]+/g, '');
                          setContactPerson(cleanedVal);

                          if (rawVal.trim() === '') {
                            setErrors(prev => ({ ...prev, contactPerson: 'Contact Person is required.' }));
                          } else if (/\d/.test(rawVal)) {
                            setErrors(prev => ({ ...prev, contactPerson: 'Contact Person should not contain numbers.' }));
                          } else if (cleanedVal.trim().length < 3) {
                            setErrors(prev => ({ ...prev, contactPerson: 'Must be at least 3 characters (letters only).' }));
                          } else {
                            setErrors(prev => ({ ...prev, contactPerson: '' }));
                          }
                        }}
                      />
                      {errors.contactPerson && <small className="text-danger d-block mt-1">{errors.contactPerson}</small>}
                    </Col>
                  </Form.Group>

                  {/* Email */}
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column sm="2">Email *</Form.Label>
                    <Col sm="5">
                      <Form.Control
                        type='email'
                        value={email}
                        placeholder='Email'
                        maxLength={50}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (val.length > 40) {
                            setErrors(prev => ({ ...prev, email: 'Mail ID cannot exceed 40 characters.' }));
                            return;
                          }

                          setEmail(val);
                          if (val.trim() === '') {
                            setErrors(prev => ({ ...prev, email: 'Email is required.' }));
                          } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                            setErrors(prev => ({ ...prev, email: 'Please enter a valid email address.' }));
                          } else {
                            setErrors(prev => ({ ...prev, email: '' }));
                          }
                        }}
                      />
                      {errors.email && <small className="text-danger d-block mt-1">{errors.email}</small>}
                    </Col>
                  </Form.Group>
                </div>

                {/* Non Mandatory Fields */}
                <div className='p-3 madatory_fields'>
                  <div className="form_section">**Non Mandatory Fields**</div>
                  {/* Phone Number */}
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextPN">
                    <Form.Label column sm="2">Phone Number</Form.Label>
                    <Col sm="5">
                      <Form.Control
                        type='text'
                        value={phoneNumber}
                        placeholder='Phone Number'
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D+/g, ''); // digits only
                          if(val.length > 15){
                            setErrors(prev => ({ ...prev, phoneNumber: 'Phone number cannot exceed maximum 15 values.' }));
                            return;
                          }
                          setPhoneNumber(val);
                          if (val && !/^\d{7,15}$/.test(val)) {
                            setErrors(prev => ({ ...prev, phoneNumber: 'Phone must be 7 to 15 digits.' }));
                          } else {
                            setErrors(prev => ({ ...prev, phoneNumber: '' }));
                          }
                        }}
                      />
                      {errors.phoneNumber && <small className="text-danger d-block mt-1">{errors.phoneNumber}</small>}
                    </Col>
                  </Form.Group>

                  {/* Address */}
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextAddress">
                    <Form.Label column sm="2">Address</Form.Label>
                    <Col sm="8">
                      <Form.Control
                        type='text'
                        value={address}
                        placeholder='Address'
                        onChange={(e) => {
                          const rawVal = e.target.value;

                          const cleanedVal = rawVal.replace(/[^A-Za-z0-9\s,./\-#&()']/g, '');
                          setAddress(cleanedVal);
                          if (rawVal.length > 150) {
                            setErrors(prev => ({ ...prev, address: 'Address cannot exceed 150 characters.' }));
                          }else if (rawVal.trim() === '') {
                            setErrors(prev => ({ ...prev, address: 'Address is required.' }));
                          } else if (cleanedVal.trim().length < 5) {
                            setErrors(prev => ({ ...prev, address: 'Address must be at least 5 characters.' }));
                          } else {
                            setErrors(prev => ({ ...prev, address: '' }));
                          }
                        }}
                      />
                      {errors.address && <small className="text-danger d-block mt-1">{errors.address}</small>}

                    </Col>
                  </Form.Group>

                  {/* Country/State/City */}
                  {/* ... your existing Country/State/City Selects stay the same ... */}

                  {/* Zip */}
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextZip">
                    <Form.Label column sm="2">Zip Code</Form.Label>
                    <Col sm="5">
                      <Form.Control
                        type='text'
                        value={zipCode}
                        placeholder='Zip Code'
                        maxLength={11}
                        onChange={(e) => {
                        const value = e.target.value;
                        if(value.length >= 11){
                          setErrors((prev) => ({...prev, zipCode: 'Zip code cannot exceeds 10 characters'}))
                          return;
                        }
                        
                        setZipCode(value);

                        if (value.trim() === '') {
                          setErrors((prev) => ({ ...prev, zipCode: 'Zip code is required.' }));
                        }else if (!/^[A-Za-z0-9\s\-]{3,10}$/.test(value)) {
                          setErrors((prev) => ({ ...prev, zipCode: 'Please enter a valid zip/postal code (3–10 letters/numbers).' }));
                        } else {
                          setErrors((prev) => ({ ...prev, zipCode: '' }));
                        }
                      }}

                      />
                      {errors.zipCode && <small className="text-danger d-block mt-1">{errors.zipCode}</small>}
                    </Col>
                  </Form.Group>

                  {/* Note */}
                  <Form.Group as={Row} className="mb-3" controlId="formPlaintextNote">
                    <Form.Label column sm="2">Note</Form.Label>
                    <Col sm="8">
                      <Form.Control
                        as="textarea"
                        value={note}
                        placeholder='Note'
                        rows={3}
                        onChange={(e) => setNote(e.target.value)}
                      />
                    </Col>
                  </Form.Group>
                </div>

                {/* Active checkbox and submit */}
                <div style={{ textAlign: "center" }}>
                  <Form.Group as={Row} className="mt-4" controlId="formPlaintextCheckbox">
                    <Col sm="5"></Col>
                    <Col sm="1">
                      <Form.Check
                        type="checkbox"
                        id="checkbox"
                        label="Is Active"
                        checked={isActive}
                        onChange={handleIsActive}
                      />
                    </Col>
                  </Form.Group>

                  {viewEditButton && (
                    <Button variant="contained" type="submit">Submit</Button>
                  )}
                  <Button variant="outlined" type="submit" className="m-4" onClick={cancelForm}>Cancel</Button>
                </div>
              </Form>
              </div>
              </div>
              </>
            )}
          </div>
      </div>
    )
}

export default Company;